import { createContext } from "react";

/**
   We use this context in the app root, because currently all of our modals are on a separate context to the parent context
   so we circumvent this by using a context in root.
   This context is currently only used for checkbox options in the product PDP.
   Honestly this solution is terrible but it saved me quite a lot of refactor time when time was something we didn't have.
**/
export const CheckBoxContext = createContext(null);
